import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW9100Component } from './kymw9100.component';
import { KYMW9101OutputModel } from '../kymw9101/vo/kymw9101-output.model';
import { LogSearchConditionModel } from './vo/log-search-condition-model';

/**
 * ログ検索画面の値を管理するクラス
 *
 * @export KYMW9100Model
 * @class KYMW9100Model
 */
export class KYMW9100Model {

  kymw9100Component: KYMW9100Component;

  public coopCodeList: Array<any> = null;
  public itemCode: string = <string>'';
  public searchTableCondition: number;
  public selectDuration: boolean;
  public updateDateFrom: string = <string>'';
  public updateDateTo: string = <string>'';
  public userID: string = <string>'';
  public orderCode: string = <string>'';
  public catalogID: string = <string>'';
  public pcode: string = <string>'';
  public totalNum = Number(0);
  public rowCntFrom = Number(0);
  public rowCntTo = Number(0);
  public aheadButtonMode: boolean = <boolean>false;
  public nextButtonMode: boolean = <boolean>false;
  public outputButtonMode: boolean = <boolean>false;
  public accessLogList: Array<any> = null;

  // 非活性用
  public prevDisabled: boolean = <boolean>false;
  public nextDisabled: boolean = <boolean>false;
  public printOutDisabled: boolean = <boolean>false;

  public commitData(serverData: any): void {
    this.totalNum = serverData.TotalCount;
    this.rowCntFrom = serverData.FromRowCnt;
    this.rowCntTo = serverData.ToRowCnt;
    this.accessLogList = serverData.LogList;
  }

  public commitParams(vo: KYMW9101OutputModel): void {
    this.coopCodeList = new Array<any>();
    if (!PlessViewUtilsSub.isEmpty(vo.coopChibaCode)) {
      this.coopCodeList.push(vo.coopChibaCode); 
    }
    if (!PlessViewUtilsSub.isEmpty(vo.coopGunmaCode)) {
      this.coopCodeList.push(vo.coopGunmaCode); 
    }
    if (!PlessViewUtilsSub.isEmpty(vo.coopIbarakiCode)) {
      this.coopCodeList.push(vo.coopIbarakiCode); 
    }
    if (!PlessViewUtilsSub.isEmpty(vo.coopNaganoCode)) {
      this.coopCodeList.push(vo.coopNaganoCode); 
    }
    if (!PlessViewUtilsSub.isEmpty(vo.coopNiigataCode)) {
      this.coopCodeList.push(vo.coopNiigataCode); 
    }
    if (!PlessViewUtilsSub.isEmpty(vo.coopSaitamaCode)) {
      this.coopCodeList.push(vo.coopSaitamaCode); 
    }
    if (!PlessViewUtilsSub.isEmpty(vo.coopTochigiCode)) {
      this.coopCodeList.push(vo.coopTochigiCode); 
    }
    if (!PlessViewUtilsSub.isEmpty(vo.coopTokyoCode)) {
      this.coopCodeList.push(vo.coopTokyoCode); 
    }
    if (!PlessViewUtilsSub.isEmpty(vo.coopKurucoCode)) {
      this.coopCodeList.push(vo.coopKurucoCode); 
    }

    this.itemCode = vo.itemCode;
    this.orderCode = vo.orderCode;
    this.catalogID = vo.catalogID;
    this.pcode = vo.pcode;
    this.searchTableCondition = vo.searchTableCondition;
    this.selectDuration = vo.selectDuration;
    this.updateDateFrom = vo.updateDateFrom;
    this.updateDateTo = vo.updateDateTo;
    this.userID = vo.userID;
  }

  public getLogSearchConditionVO(): LogSearchConditionModel {
    const vo: LogSearchConditionModel = new LogSearchConditionModel();
    vo.searchTableCondition = this.searchTableCondition;
    vo.orderCode = this.orderCode;
    vo.coopCodeList = this.coopCodeList;
    vo.pcode = this.pcode;
    vo.itemCode = this.itemCode;
    vo.userID = this.userID;
    vo.updateDateFrom = this.updateDateFrom;
    vo.updateDateTo = this.updateDateTo;
    vo.pageNum = this.kymw9100Component.currentPageNo;
    vo.sortColumnName = this.kymw9100Component.sortTarget;
    vo.sortKind = this.kymw9100Component.sortOrder;

    return vo;
  }

}
